(function () {
    "use strict";

    angular.module("app.common").directive("shareThis", shareThis);

    shareThis.$injects = ["$timeout", "$window"];

    function shareThis($timeout, $window) {
        function createHtml(url, description, title) {
            return (
                // '<div class="sharethis-inline-share-buttons" ' +
                // 'data-url="' +
                // url +
                // '" ' +
                // 'data-description="' +
                // description +
                // '" ' +
                // 'data-title="' +
                // title +
                // '">' +
                //"</div>"
                '<div class="sharethis-inline-share-buttons"></div>'
            );
        }

        return {
            restrict: "EA",
            scope: {},
            link: function postLink(scope, element, attrs) {
                element.html(createHtml(attrs.url, attrs.description, attrs.title));
                $timeout(function () {
                    if ($window.__sharethis__) {
                        $window.__sharethis__.initialize();
                        // if (attrs.url) {
                        //     var url =
                        //         attrs.url.indexOf("http") > -1 ?
                        //         attrs.url :
                        //         "https://" + attrs.url;
                        //     $window.addthis.toolbox(
                        //         $(element).get(), {}, {
                        //             url: url,
                        //             title: attrs.title,
                        //             description: attrs.description,
                        //         }
                        //     );
                        // } else {
                        //     $window.addthis.toolbox($(element).get());
                        // }
                        // if ($window.addthis.layers.refresh) {
                        //     $window.addthis.layers.refresh();
                        // }
                    }
                }, 300);
            },
        };
    }
})();